import React, { Component } from "react";
import PageProjectThumb from './PageProjectThumb';

export default class PageProjects extends Component {
	
	constructor(){
		super()
		this.state = {
			offsetLeft:0
		}
		this.handleResize = this.handleResize.bind(this);
	}
    
	componentDidMount() {
	  	window.addEventListener('resize', this.handleResize);
	  	setTimeout(() => {
	  		this.handleResize();
	  	}, 0);
  	}
  	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
        
    handleResize() {
	  	if (this.firstThumb) {
	  		this.setState({offsetLeft : (this.firstThumb.offsetLeft * 2)});
	  	}
  	}
  		
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className="c-page__block c-page__block--load-effect c-projects">
			    			    		
		    		<div className="l-grid">
			    			
				    	{block.project.map((project,i) =>
							{	
								if (i % 5 === 0 || i % 5 === 1 || i % 5 === 2) {
									
									return (
										 
										<div className="c-projects__thumb-wrapper l-grid__col l-grid__col--m-4-12" key={i} style={{paddingBottom:this.state.offsetLeft+'px'}}>
										
											<PageProjectThumb item={project}></PageProjectThumb>
											
										</div>
										
									)
							
								} else {
									
									return (
										
										<div className="c-projects__thumb-wrapper l-grid__col l-grid__col--m-6-12" key={i} style={{paddingBottom:this.state.offsetLeft+'px'}}>
										
											<PageProjectThumb item={project}></PageProjectThumb>
											
										</div>
										
									)
									
								}
							}
						)}
																									
					</div>		
												    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
